module.exports = __webpack_public_path__ + "img/Dox-walking-button-active.55eb0258.svg";